import localizationEnUsPageHeader from "./en-us/page-header.json";
import localizationEnUsPageTabPanel from "./en-us/page-tabpanel.json";
import localizationEnUsSectionCashRegister from "./en-us/section-cash-register.json";
import localizationEnUsSectionHardware from "./en-us/section-hardware.json";
import localizationEnUsSectionInformation from "./en-us/section-information.json";
import localizationEnUsSectionLicenses from "./en-us/section-licenses.json";

export const localizationEnUsBusinessUnit = {
  ...localizationEnUsPageHeader,
  ...localizationEnUsPageTabPanel,
  ...localizationEnUsSectionCashRegister,
  ...localizationEnUsSectionHardware,
  ...localizationEnUsSectionInformation,
  ...localizationEnUsSectionLicenses,
};
